import { Box, type BoxProps } from '@lemonade-hq/cdk';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import type React from 'react';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

interface SectionEventWrapperProps extends BoxProps, React.ComponentProps<'div'> {
  children: React.ReactNode;
  name: string;
  page: 'renters' | 'homeowners' | 'home' | 'car' | 'life' | 'bundles' | 'pet';
}

export const SectionEventWrapper: React.FC<SectionEventWrapperProps> = ({
  name: section_name,
  page,
  children,
  ...props
}) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const { trackEvent } = useAnalyticsContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies:  justification: inView is the only dependency
  useEffect(() => {
    if (inView) {
      trackEvent('page.section.viewed', {
        section_name,
        page,
      });
    }
  }, [inView]);

  return (
    <Box ref={ref} {...props}>
      {children}
    </Box>
  );
};
